/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { getAllClientsRequest } from 'modules/clients/actions';
import {
  ListClientsAppsFields,
  ListClientsAppsProps,
} from 'modules/environments/interfaces';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import {
  changeStateClientsApplicationsAutoskyRequest,
  getClientsApplicationsAutoskyRequest,
} from 'modules/environments/actions';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ScreenStatesApplications from 'containers/Clients/ApplicationsClients/ScreenStatesApplications';
import AutoSwitch from 'components/AutoSwitch';
import Button from 'components/Button';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import palette from 'theme/palette';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import styles, { overrideSwitch } from './styles';

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  appName: string;
  isLoadingClientsApps: boolean;
  clientsApplicationsList: ListClientsAppsProps;
  getClientsApplicationsAutoskyRequest: (props) => void;
  changeStateClientsApplicationsAutoskyRequest: (props) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
}

const ListApplicationClientsState = ({
  appName,
  isLoadingClientsApps,
  clientsApplicationsList,
  getClientsApplicationsAutoskyRequest,
  changeStateClientsApplicationsAutoskyRequest,
  modalClose,
  modalOpen,
}: Props) => {
  const {
    query,
    searchValue,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);
  const [state, setState] = React.useState<boolean>(true);
  const [activeAll, setActiveAll] = React.useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [checks, setChecks] = React.useState<string[]>([]);
  const classes = makeStyles(styles(state))();

  const getClientsApplicationsAutosky = () => {
    getClientsApplicationsAutoskyRequest({
      id,
      query,
      name: appName,
      state: state ? 'inactive' : 'active',
    });
  };

  React.useEffect(() => {
    if (query.search === '') {
      getClientsApplicationsAutosky();
    }
  }, [getClientsApplicationsAutoskyRequest, id, query, appName, state]);

  React.useEffect(() => {
    if (query.search !== '') {
      getClientsApplicationsAutosky();
    }
  }, [getClientsApplicationsAutoskyRequest, id, query, appName, state]);

  const handleAllCheck = () => {
    if (!selectedAll) {
      const ids: string[] = [];
      clientsApplicationsList.results.forEach(item => ids.push(item?.app_uuid));
      setChecks(ids);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string) => {
    const findCheckId = checks.find(item => item === uuid);
    if (!findCheckId) {
      setChecks([...checks, uuid]);
    } else {
      const index = checks.indexOf(findCheckId);
      checks.splice(index, 1);
      setChecks([...checks]);
    }
  };

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid container justify="center">
        <AutoSwitch
          overrideClasses={overrideSwitch(state)}
          label={
            <Typography className={classes.switchText}>
              {state ? i18n.t('ACTIVATE_KEY') : i18n.t('INACTIVATE_KEY')}
            </Typography>
          }
          id="toggle-activate-inactivate"
          size="medium"
          onChange={() => setState(!state)}
          checked={state}
        />
      </Grid>
      <Grid container>
        <Grid
          container
          justify="flex-start"
          className={classes.checkboxActivateAll}
        >
          <Checkbox
            onChange={() => {
              setActiveAll(!activeAll);
              setChecks([]);
            }}
            checked={activeAll}
            id="change-all-clients"
          />
          <Typography className={classes.activeAllText}>
            {state
              ? i18n.t('ACTIVATE_IN_ALL_CLIENTS_KEY')
              : i18n.t('INACTIVATE_IN_ALL_CLIENTS_KEY')}
          </Typography>
        </Grid>
        {!activeAll && (
          <>
            <SearchBar
              id="search-client"
              isLoading={isLoadingClientsApps}
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
            />
            <TableItems
              header={
                <>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={handleAllCheck}
                      id="select-all-applications-environment"
                    />
                  </TableCell>
                  <TableCell className={classes.tableRow}>
                    {i18n.t('CLIENT_NAME_KEY')}
                  </TableCell>
                  <TableCell centerTitle className={classes.state}>
                    {i18n.t('STATUS_KEY')}
                  </TableCell>
                </>
              }
              renderItems={(item: ListClientsAppsFields, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={() => handleCheck(item?.app_uuid)}
                      checked={!!checks.find(check => check === item?.app_uuid)}
                    />
                  </TableCell>
                  <TableCell>{item?.client.name}</TableCell>
                  <TableCell textAlignCenter centerTitle>
                    <ScreenStatesApplications type={item?.state} />
                  </TableCell>
                </TableRow>
              )}
              isLoading={isLoadingClientsApps}
              data={clientsApplicationsList}
              onChangeLimit={handleLimitChange}
              onChangePage={handlePageChange}
              notFoundText={i18n.t('NO_CLIENT_KEY')}
              smallLoading={true}
            />
          </>
        )}
      </Grid>
      <Grid container justify="flex-end" className={classes.buttons}>
        {state ? (
          <Button
            id="activate-button"
            submitButton
            disabled={checks.length === 0 && !activeAll}
            onClick={() => {
              modalOpen({
                title: i18n.t(
                  'APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_TITLE_KEY',
                  {
                    app_name: appName,
                  }
                ),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon
                        style={{
                          color: palette.deepBlue,
                          width: 30,
                          height: 30,
                        }}
                      />
                    </Grid>
                    <Grid container justify="center">
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t(
                          'APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_KEY',
                          {
                            app_name: appName,
                          }
                        )}
                      </Typography>
                    </Grid>
                  </>
                ),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="confirm-active-button"
                      onClick={() => {
                        changeStateClientsApplicationsAutoskyRequest({
                          id,
                          name: appName,
                          query,
                          state: 'active',
                          app_uuids: checks,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_ACTIVE_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              });
            }}
          >
            {i18n.t('ACTIVATE_KEY')}
          </Button>
        ) : (
          <Button
            id="inactivate-button"
            deleteButton
            disabled={checks.length === 0 && !activeAll}
            onClick={() => {
              modalOpen({
                title: i18n.t(
                  'APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_TITLE_KEY',
                  {
                    app_name: appName,
                  }
                ),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon
                        style={{
                          color: palette.deepBlue,
                          width: 30,
                          height: 30,
                        }}
                      />
                    </Grid>
                    <Grid container justify="center">
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t(
                          'APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_KEY',
                          {
                            app_name: appName,
                          }
                        )}
                      </Typography>
                    </Grid>
                  </>
                ),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="confirm-inactive-button"
                      onClick={() => {
                        changeStateClientsApplicationsAutoskyRequest({
                          id,
                          name: appName,
                          query,
                          state: 'inactive',
                          app_uuids: checks,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_INACTIVE_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              });
            }}
          >
            {i18n.t('INACTIVATE_KEY')}
          </Button>
        )}

        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CLOSE_KEY')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: {
    isLoadingClientsApps,
    clientsApplicationsList,
    environmentSelected,
  },
}: ApplicationState) => ({
  isLoadingClientsApps,
  clientsApplicationsList,
  environmentSelected,
});

export default connect(mapStateToProps, {
  getClientsApplicationsAutoskyRequest,
  getAllClientsRequest,
  modalClose,
  changeStateClientsApplicationsAutoskyRequest,
  modalOpen,
})(ListApplicationClientsState);
